import { render, staticRenderFns } from "./DataTableLocalSort.vue?vue&type=template&id=153c46b0"
import script from "./DataTableLocalSort.vue?vue&type=script&lang=js"
export * from "./DataTableLocalSort.vue?vue&type=script&lang=js"
import style0 from "./DataTableLocalSort.vue?vue&type=style&index=0&id=153c46b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports